














































































































































































































import { PropType, defineComponent, computed, ComputedRef, getCurrentInstance } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import { useCommonHooks } from './help';
import {
  IntentCodeType,
  ReportDataType,
  CommonType,
  CustomCommonType,
  ProgressCodeType,
  StatisticType,
  ProgressType,
  GroupData,
  CodeType
} from './type';
import AsyncLoading from './async-loading.vue';
import { useIssue } from '../../../hooks/useIssue';
import { useRender } from '../../../hooks/useRender';

export default defineComponent({
  components: {
    AsyncLoading
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const instance = getCurrentInstance();
    const showDailyField: Array<('finishWork' | 'inProgressWork' | 'overDueWork') & (keyof ReportDataType)> =
      ['finishWork', 'inProgressWork', 'overDueWork'];
    const intentCode = props.message.content.report.base.intentCode as IntentCodeType;
    const reportData = computed(() => {
      return props.message.content.report.reportData as ReportDataType;
    });
    const reportType = props.message.content.report.reportType;
    const {
      memberIntentCodeTranslateMap,
      unitTranslateMap,
      transformUnitByStatisticType,
      transformIssueText,
      transformListNeedData,
      transformSummaryNeedData
    } = useCommonHooks();
    const fixedTitleMap = memberIntentCodeTranslateMap[intentCode];
    const workStatisticType = computed(() => reportData.value.workStatisticType || 'point') as ComputedRef<StatisticType>;
    const listMap = computed(() => {
      const final = showDailyField.filter(
        (key): Boolean => (key === 'finishWork' || key === 'inProgressWork' || reportData.value[key]!?.issueIds?.length > 0)
      );

      return final.map((key): CustomCommonType => {
        const content = (reportData.value?.[key]?.content?.length || 0) > 6 ? reportData.value[key]?.content.slice(0, 6)
          : reportData.value[key]?.content;

        return {
          type: intentCode === 'weekly_report' ? 'group' : 'item',
          key,
          ...(reportData.value[key] as CommonType),
          content: intentCode === 'weekly_report' ? (content || []) : (reportData.value?.[key]?.content || [])
        };
      });
    });
    const { openIssue } = useIssue();
    const { openAside } = useRender();

    const openIssueDetail = (issue: any) => {
      openIssue(issue);
    };
    const openAsideComponent = (
      issueIds: Array<number>,
      type: string,
      hasGroup?: Array<GroupData> | null,
      trackType?: string,
      trackParam?: any
    ) => {
      openAside(() => import('../../aside-component/IssueList.vue'), {
        ...props.message,
        title: `${t('saas.robotChat.member')} ${reportData.value.username} ${t('efficiency.git.deployBarTooltipX')} ${reportData.value.reportDate} ${type}`,
        content: {
          issueIds: issueIds,
          loadListById: true,
          hasGroup
        }
      });


      if (trackType) {
        instance?.proxy.$track.send(trackType, trackParam, true);
      }
    };

    const summaryList = computed(() => {
      const o = {
        finish: reportData.value.progress.finish,
        inProgress: reportData.value.progress.inProgress,
        overDue: reportData.value.progress.overDue
      };
      if (reportData.value.progress.overDue.issueCount < 1) {
        Reflect.deleteProperty(o, 'overDue');
      }
      return o;
    }) as ComputedRef<ProgressType>;
    const showPointOrIssueByCondition = computed(() => {
      const s:Array<ProgressCodeType> = ['finish', 'inProgress', 'overDue'];
      const p = s.some(key => {
        return summaryList.value[key]?.point > 0;
      });
      const l = s.some(key => {
        return summaryList.value[key]?.labour > 0;
      });
      return {
        showPoint: p,
        showLabour: l
      };
    });
    const allSummaryList = computed<number[]>(() => {
      const keys = Object.keys(reportData.value.progress) as Array<ProgressCodeType>;
      return keys.reduce((acc: number[], key: ProgressCodeType): Array<number> => {
        return [...acc, ...reportData.value.progress[key]?.issueIds];
      }, []);
    });
    const noDailyTransformListNeedData = (key: CodeType, list: CustomCommonType[]) => {
      if (intentCode === 'daily_report') {
        return [];
      }
      return transformListNeedData(key, list);
    };
    return {
      t,
      tc,
      reportType,
      reportData,
      intentCode,
      workStatisticType,
      unitTranslateMap,
      transformUnitByStatisticType,
      fixedTitleMap,
      listMap,
      openIssueDetail,
      openAsideComponent,

      summaryList,
      allSummaryList,
      showPointOrIssueByCondition,
      transformIssueText,
      noDailyTransformListNeedData,
      transformSummaryNeedData
    };
  }
});
